// extracted by mini-css-extract-plugin
module.exports = {"bigger":"radio-item_bigger__NoWLv","checked":"radio-item_checked__DVNP8","item":"radio-item_item__K386s"};